module.exports = __webpack_public_path__ + "img/747405.b1e38ee6.jpg";